import React, { Component } from "react";
import { connect } from "react-redux";
import {
  requestServerGet,
  requestServerPost,
  selectBranch,
  selectBrand,
  selectPage,
} from "../../actions";
import MainLayout from "../../components/layouts/main";
import ScreenTableView from "../../components/views/ScreenTableView";
import PageLoader from "../../components/PageLoader";
import PrimaryActionButton from "../../components/PrimaryActionButton";
import Constants from "../../data/constants";

import { Alert, Button, message, Modal, Table, Tag, Tooltip } from "antd";
import {
  // useNavigate,
  useHistory,
} from "react-router-dom";
import firebase from "../../Firebase";
import DataHelper from "../../helpers/DataHelper";
import PeerHelper from "../../helpers/PeerHelper";
import PopupManager from "../../managers/PopupManager";
// import Modal from 'antd/lib/modal/Modal';
import { ExclamationCircleOutlined, LockOutlined } from "@ant-design/icons";
import MediaPreviewPopup from "../../components/popups/MediaPreviewPopup";
import ScreenPreviewPopup from "../../components/popups/ScreenPreviewPopup";
import {
  preparePlaylists,
  prepareTimelineElements,
} from "../../helpers/ContentJsonHelper";
import PermissionManager from "../../managers/PermissionManager";
import APIManager from "../../managers/APIManager";
import { THEME_PALLETE } from "../../Theme";
import { CHECK_LICENSE } from "../../Config";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const { Column, ColumnGroup } = Table;

const ScreenPage = (props) => {
  // let navigate = useNavigate();
  const history = useHistory();
  const { lang } = useProLanguage();
  return (
    <ScreenPageClass history={history} lang={lang} {...props}></ScreenPageClass>
  );
};

class ScreenPageClass extends Component {
  constructor(props) {
    super(props);
    this.childChangeCallbacks = [];
    this.state = {
      screensData: [],
      screenEventsData: [],
      eventTypesData: [],
      branchData: null,
      streamscreenvisible: false,
      currentStreamScreenData: null,
      loading: false,
      licensesData: [],
      selectedScreen: null,
      selectedLocationLabel: null,
    };
    this.screenStreamingPopupRef = React.createRef();
    this.mediaPreviewPopupRef = React.createRef();
    this.screenPreviewPopupRef = React.createRef();
  }

  componentDidMount() {
    this.reloadPage();
  }

  reloadLicenses = () => {
    const { selectedBrandData } = this.props;
    console.log("reloadLicenses");

    this.setState({ loading: true });
    APIManager.requestWarroomServerPost(
      "get_licenses",
      { brand_id: selectedBrandData.BrandID },
      {},
    )
      .then((response) => {
        console.log("reloadLicenses loaded " + response);
        if (response && "data" in response) {
          var licenses = response.data;

          this.setState({ licensesData: licenses });
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        console.log("get_token error " + JSON.stringify(error));
        this.setState({ loading: false });
      });
  };

  componentDidUpdate(prevProps) {
    const branchChanged =
      prevProps.selectedBranchData !== this.props.selectedBranchData;
    const brandChanged =
      prevProps.selectedBrandData !== this.props.selectedBrandData;
    if (branchChanged || brandChanged) {
      const newState = {};
      if (branchChanged) newState.branchData = this.props.selectedBranchData;
      if (brandChanged) newState.brandData = this.props.selectedBrandData;
      this.setState(newState, () => this.reloadPage());
    }

    // When the user clicks the Screens sidebar item while already on this page
    // (same page ID but new Redux object = selectPage dispatched again),
    // go back to the screen list if a detail view is open.
    const prevPageId = prevProps.selectedPage?.id;
    const currPageId = this.props.selectedPage?.id;
    if (
      currPageId === Constants.SCREEN_PAGE &&
      prevPageId === Constants.SCREEN_PAGE &&
      prevProps.selectedPage !== this.props.selectedPage &&
      this.state.selectedScreen
    ) {
      this.setState({ selectedScreen: null });
    }
  }

  reloadPage = async () => {
    const {
      selectedBrandData,
      selectedBranchData,
      requestServerGet,
      userdata,
    } = this.props;

    if (selectedBrandData && !this.state.brandData) {
      this.setState({ brandData: selectedBrandData }, () => {
        this.reloadPage();
      });
      return;
    }
    if (selectedBranchData && !this.state.branchData) {
      this.setState({ branchData: selectedBranchData }, () => {
        this.reloadPage();
      });
      return;
    }

    console.log("reloadPage 1");
    if (!this.state.branchData) {
      return;
    }
    console.log("reloadPage 2");
    if (!this.state.brandData) {
      return;
    }
    console.log("reloadPage 3");

    this.setState({ loading: true });
    DataHelper.getScreens(
      {
        brandid: this.state.brandData.BrandID,
        branchid: this.state.branchData.BranchID,
      },
      this.props,
    )
      .then((response) => {
        console.log("response " + JSON.stringify(response));
        requestServerGet(
          "get_screeneventplaylists",
          {
            brandid: this.state.brandData.BrandID,
            branchid: this.state.branchData.BranchID,
          },
          null,
          (eventresponse) => {
            requestServerGet(
              "get_eventtypes",
              {},
              null,
              (eventTyperesponse) => {
                this.setState(
                  {
                    screensData: response,
                    screenEventsData: eventresponse.data,
                    eventTypesData: eventTyperesponse.data,
                    loading: false,
                  },
                  () => {
                    if (CHECK_LICENSE) this.reloadLicenses();
                  },
                );
              },
              userdata.token,
            );
          },
          userdata.token,
        );
      })
      .catch(() => {
        this.setState({ loading: false });
      });

    // requestServerGet("get_screens", { brandid: this.state.brandData.BrandID, branchid: this.state.branchData.BranchID }, null, (response) => {

    //     requestServerGet("get_screeneventplaylists", { brandid: this.state.brandData.BrandID, branchid: this.state.branchData.BranchID }, null, (eventresponse) => {

    //         requestServerGet("get_eventtypes", {}, null, (eventTyperesponse) => {
    //             this.setState({ screensData: response.data, screenEventsData: eventresponse.data, eventTypesData: eventTyperesponse.data })

    //         }, userdata.token)

    //     }, userdata.token)
    // }, userdata.token)
  };

  launchCreateScreen = () => {
    PopupManager.launchCreateScreenPopup(this.reloadPage);
  };

  destroyPeer = (screendata) => {
    if (PeerHelper.peer) PeerHelper.peer.destroy();
    PeerHelper.peer = null;
    if (!this.state.currentStreamScreenData) return;

    const {
      AccountCode = "",
      BrandCode = "",
      BranchCode = "",
      ScreenCode = "",
    } = this.state.currentStreamScreenData;
    const db = firebase
      .database()
      .ref()
      .child(`${AccountCode}/${BrandCode}/${BranchCode}/${ScreenCode}`);

    this.setState({ currentStreamScreenData: null });
    // console.log(roomId + " set " + key + " " + value );
    if (db) db.child("cms_peer_id").set("");
  };

  previewScreenCapture = (screendata) => {
    const { usertoken, requestServerGet, selectedBrandData } = this.props;

    requestServerGet(
      "get_screenshot",
      { screenid: screendata.ScreenID },
      null,
      (response) => {
        if (response.data.length) {
          const { ScreenShot = "" } = response.data[0];
          const d = {
            FileType: "image",
            FileID: -1,
            UploadFile: ScreenShot,
            scale: "contain",
          };
          if (this.mediaPreviewPopupRef.current) {
            this.mediaPreviewPopupRef.current.previewMedia(d);
          }
        }
      },
      usertoken,
    );
  };

  previewScreenContent = (screendata, previewDims) => {
    if (!screendata || !screendata.CampaignID || screendata.CampaignID === "") {
      message.warning("Link a schedule to this screen before previewing.");
      return;
    }
    const { usertoken, requestServerGet } = this.props;
    requestServerGet(
      "preview_content",
      { campaignid: screendata.CampaignID },
      null,
      (response) => {
        const contentJSON = response.data;
        if (!contentJSON) return;
        prepareTimelineElements(contentJSON.campaign);
        preparePlaylists(contentJSON.playlists, true);
        if (this.screenPreviewPopupRef.current) {
          this.screenPreviewPopupRef.current.previewContent(
            contentJSON,
            previewDims,
          );
        }
      },
      usertoken,
    );
  };

  getScreensView = () => {
    const {
      usertoken,
      requestServerPost,
      selectedBrandData,
      selectedBranchData,
      history,
      selectPage,
      globalSearch,
    } = this.props;
    const t = (PRO_TRANSLATIONS[this.props.lang] || PRO_TRANSLATIONS.en).screen;
    // console.log("getScreensView " + this.state.screensData.length)

    const filteredData = this.state.screensData.filter((data) => {
      return data.ScreenName.toLocaleLowerCase().includes(
        globalSearch.toLocaleLowerCase(),
      );
    });

    const createPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_SCREEN,
      PermissionManager.PERMISSION_TYPE_CREATE,
    );
    const {
      usedScreens = 0,
      totalScreens = 0,
      remainingScreens = 0,
    } = DataHelper.getScreensUsage(this.state.licensesData, "sum");
    return (
      <MainLayout
        id={Constants.SCREEN_PAGE}
        preventDefaultStepBack={!!this.state.selectedScreen}
        quietTitleBar={true}
        style={{ padding: 20 }}
        onBackClicked={() => {
          if (this.state.selectedScreen)
            this.setState({ selectedScreen: null });
        }}
        renderBreadCrumb={() => [
          <span
            onClick={() => this.setState({ selectedScreen: null })}
            style={{ fontSize: 14, fontWeight: 600, color: "#64748b", padding: "4px 8px", lineHeight: "22px", cursor: "pointer" }}
          >
            {t.title || "Screen"}
          </span>,
          this.state.selectedScreen && [
            "/",
            <span
              style={{ fontSize: 14, fontWeight: 500, color: "#94a3b8", padding: "4px 8px", lineHeight: "22px" }}
            >
              {this.state.selectedScreen.ScreenName}
            </span>,
          ],
        ]}
      >
        <Modal
          centered
          footer={false}
          open={this.state.streamscreenvisible}
          width={"auto"}
          height="auto"
          closable={false}
          bodyStyle={{ backgroundColor: "black" }}
          onCancel={() => {
            this.setState({ streamscreenvisible: false });

            this.destroyPeer();
          }}
        >
          <video
            type="video/mp4"
            id="screenvideo"
            ref={this.videoRef}
            style={{ width: "100%", maxWidth: "100%", maxHeight: "70vh" }}
          ></video>
        </Modal>
        {remainingScreens == 0 && this.state.licensesData.length > 0 && (
          <Alert
            style={{ marginBottom: "15px" }}
            message={t.licenseAlert}
            type="warning"
          ></Alert>
        )}

        {/* Page Header — hidden in detail view (detail renders its own header) */}
        {!this.state.selectedScreen && (
        <div className="cms-page-header">
          <div className="cms-page-header-info">
            <div
              className="cms-page-header-icon"
              style={{ background: "linear-gradient(135deg, #eef2ff, #e0e7ff)" }}
            >
              <svg
                width="26"
                height="26"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#6366f1"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
              </svg>
            </div>
            <div className="cms-page-header-text">
              <h1>{t.title}</h1>
              {this.state.selectedLocationLabel ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                    marginTop: 3,
                  }}
                >
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#6366f1"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                  <span
                    style={{ fontSize: 13, color: "#6366f1", fontWeight: 600 }}
                  >
                    {this.state.selectedLocationLabel}
                  </span>
                </div>
              ) : (
                <p>{t.subtitle}</p>
              )}
            </div>
          </div>
          {createPermission ? (
            <PrimaryActionButton
              className="cms-page-header-action"
              disabled={remainingScreens == 0 && CHECK_LICENSE}
              onClick={this.launchCreateScreen}
            >
              {CHECK_LICENSE
                ? t.pairNewScreenCount(usedScreens, totalScreens)
                : t.pairNewScreen}
            </PrimaryActionButton>
          ) : null}
        </div>
        )}
        {/* <Tag style={{float:"right"}} color={THEME_PALLETE.purple}>5/10 Screens Used</Tag> */}
        {this.state.loading ? (
          <PageLoader text={t.loadingScreens} />
        ) : (
          <ScreenTableView
            parentProps={this.props}
            key="screen_table_view"
            data={filteredData}
            eventData={this.state.screenEventsData}
            onNeedsReload={this.reloadPage}
            onLocationChange={(label) =>
              this.setState({ selectedLocationLabel: label })
            }
            eventTypesData={this.state.eventTypesData}
            onRowClicked={this.onCampaignContentClicked}
            selectedScreen={this.state.selectedScreen}
            onSelectScreen={(screen) =>
              this.setState({ selectedScreen: screen })
            }
            onScreenClicked={(screenData) => {
              console.log("onScreenClicked " + screenData.ScreenID);
            }}
            onCampaignClicked={(screenData) => {
              if ("CampaignID" in screenData && screenData.CampaignID !== "") {
                selectPage(
                  Constants.CAMPAIGN_PAGE,
                  {
                    id: screenData.CampaignID,
                    fromPage: Constants.SCREEN_PAGE,
                  },
                  true,
                );
              } else {
                PopupManager.launchEditScreenPopup(screenData, () => {
                  this.reloadPage();
                });
              }
            }}
            onEditContent={(screenData) => {
              const {
                requestServerGet,
                userdata,
                selectedBrandData,
                selectPage,
              } = this.props;
              requestServerGet(
                "get_timelines",
                {
                  brandid: selectedBrandData.BrandID,
                  campaignid: screenData.CampaignID,
                },
                null,
                (response) => {
                  const timelines = response.data || [];
                  //onlyt one timeline, go directly to campaign page with that timeline
                  if (timelines.length == 1) {
                    selectPage(
                      Constants.CAMPAIGN_PAGE,
                      {
                        id: screenData.CampaignID,
                        timelineid: timelines[0].TimelineID,
                        fromPage: Constants.SCREEN_PAGE,
                      },
                      true,
                    );
                  } else {
                    selectPage(
                      Constants.CAMPAIGN_PAGE,
                      {
                        id: screenData.CampaignID,
                        fromPage: Constants.SCREEN_PAGE,
                      },
                      true,
                    );
                  }
                },
                userdata.token,
              );
            }}
            onRemoteAction={(action, screenstatus, screendata, param = {}) => {
              console.log("action " + action);
              console.log("screenstatus " + JSON.stringify(screenstatus));
              console.log("screendata " + JSON.stringify(screendata));

              const {
                AccountCode = "",
                BrandCode = "",
                BranchCode = "",
                ScreenCode = "",
              } = screendata;
              const db = firebase
                .database()
                .ref()
                .child(
                  `${AccountCode}/${BrandCode}/${BranchCode}/${ScreenCode}`,
                );

              switch (action) {
                case "unlock":
                  Modal.confirm({
                    title: t.unlockTitle,
                    icon: <LockOutlined />,
                    // footer: null,
                    maskClosable: true,
                    okText: t.unlockBtn,
                    onOk: () => {
                      if (db) db.child("lock").set(0);
                      Modal.destroyAll();
                    },
                  });
                  break;
                case "lock":
                  if (!("code" in param)) return;

                  Modal.confirm({
                    title: t.lockTitle(param.code),
                    icon: <LockOutlined />,
                    // footer: null,
                    maskClosable: true,
                    onOk: () => {
                      if (db) db.child("lock").set(param.code);
                      Modal.destroyAll();
                    },
                  });
                  break;
                case "reboot_hardware":
                  Modal.confirm({
                    title: t.confirm,
                    icon: <ExclamationCircleOutlined />,
                    content: t.rebootContent(screendata.ScreenName),
                    okText: t.ok,
                    cancelText: t.cancel,
                    onOk: () => {
                      if (db) db.child("needs_reboot_hardware").set(1);
                    },
                  });
                  break;
                case "shutdown_hardware":
                  Modal.confirm({
                    title: t.confirm,
                    icon: <ExclamationCircleOutlined />,
                    content: t.shutdownContent(screendata.ScreenName),
                    okText: t.ok,
                    cancelText: t.cancel,
                    onOk: () => {
                      if (db) db.child("needs_shutdown_hardware").set(1);
                    },
                  });
                  break;

                case "toggle_play":
                  // Modal.confirm({
                  //     title: 'Confirm',
                  //     icon: <ExclamationCircleOutlined />,
                  //     content: `By pressinig OK, this screen '${screendata.ScreenName}' will instantly be shutdown. Do you want to proceed?`,
                  //     okText: 'OK',
                  //     cancelText: 'Cancel',
                  //     onOk: () => {
                  if (db) db.child("needs_toggle_playstate").set(1);
                  //     }
                  // });
                  break;
                case "reload_player":
                  // Modal.confirm({
                  //     title: 'Confirm',
                  //     icon: <ExclamationCircleOutlined />,
                  //     content: `By pressinig OK, this screen '${screendata.ScreenName}' will instantly be shutdown. Do you want to proceed?`,
                  //     okText: 'OK',
                  //     cancelText: 'Cancel',
                  //     onOk: () => {
                  if (db) db.child("needs_reload_player").set(1);
                  //     }
                  // });
                  break;
                case "capture_screen":
                  if (db) {
                    const callback = db.on("child_changed", (snap) => {
                      if (snap.key === "needs_capture_screen") {
                        if (snap.val() === 2) {
                          // console.log("screen capture received")

                          this.childChangeCallbacks.forEach((cb) => {
                            db.off("child_changed", cb);
                          });

                          this.childChangeCallbacks = [];

                          this.previewScreenCapture(screendata);
                        } else {
                          // console.log("screen capture not received")
                        }
                      }
                    });

                    this.childChangeCallbacks.push(callback);
                    db.child("needs_capture_screen").set(1);
                  }
                  break;
                case "stream_screen":
                  if ("peer_id" in screenstatus) {
                    if (!PeerHelper.peer) {
                      console.log("PeerHelper.initPeer");
                      PeerHelper.initPeer({
                        isInitiator: false,
                        onSignal: (peerID) => {
                          // console.log(roomId + " set " + key + " " + value );
                          if (db) db.child("cms_peer_id").set(peerID);
                        },
                        onClose: () => {
                          this.destroyPeer();
                        },
                        onStream: (stream) => {
                          console.log("STREAMING!!!");

                          this.setState(
                            {
                              streamscreenvisible: true,
                              currentStreamScreenData: screendata,
                            },
                            () => {
                              setTimeout(() => {
                                var video =
                                  document.getElementById("screenvideo");
                                if ("srcObject" in video) {
                                  video.srcObject = stream;
                                } else {
                                  video.src =
                                    window.URL.createObjectURL(stream); // for older browsers
                                }

                                video.play();
                              }, 1000);
                            },
                          );

                          // video.play();

                          // this.screenStreamingPopupRef.current.streamScreen(stream)
                          // ScreenStreamingPopup.streamScreen(stream)
                        },
                      });
                      PeerHelper.connectToID(screenstatus.peer_id);
                    }
                  }
                  break;
              }
            }}
            onNeedsUnpair={(screenData) => {
              Modal.confirm({
                title: t.confirm,
                icon: <ExclamationCircleOutlined />,
                content: t.unpairContent(screenData.ScreenName),
                okText: t.ok,
                cancelText: t.cancel,
                centered: true,
                onOk: () => {
                  const db = firebase
                    .database()
                    .ref()
                    .child(
                      `${screenData.AccountCode}/${screenData.BrandCode}/${screenData.BranchCode}/${screenData.ScreenCode}`,
                    );

                  // console.log(roomId + " set " + key + " " + value );
                  if (db) {
                    // if (db.child("is_paired") === 1) {
                    db.child("needs_unpair").set(1);
                    db.child("is_paired").set(0);
                    db.child("os").set("");
                    db.child("os_version").set("");
                    // db.child("is_paired").set(0);
                    // }
                  }

                  message.success(t.deletedSuccess(screenData.ScreenName));
                  this.reloadPage();
                },
              });
            }}
            onDelete={(screenData) => {
              const sData = screenData;
              // console.log("delete screen " + JSON.stringify(screenData))
              // return
              requestServerPost(
                "delete_screen",
                { screenid: sData.ScreenID },
                {},
                () => {
                  const db = firebase
                    .database()
                    .ref()
                    .child(
                      `${screenData.AccountCode}/${screenData.BrandCode}/${screenData.BranchCode}/${screenData.ScreenCode}`,
                    );

                  // console.log(roomId + " set " + key + " " + value );
                  if (db) db.child("needs_unpair").set(1);

                  message.success(t.deletedSuccess(sData.ScreenName));
                  this.reloadPage();
                },
                usertoken,
              );
            }}
            onEdit={(screenData) => {
              PopupManager.launchEditScreenPopup(screenData, () => {
                this.reloadPage();
              });
              // console.log("edit edit")
            }}
            onEditBrightness={(screenData) => {
              PopupManager.launchEditScreenBrightnessPopup(screenData, () => {
                this.reloadPage();
              });
            }}
            onDuplicate={(screenData) => {}}
            onPairScreen={(screenData) => {
              PopupManager.launchPairscreenPopup(screenData, this.reloadPage);
            }}
            onPairNewScreen={this.launchCreateScreen}
            onPublish={(screenData) => {
              const sData = screenData;
              try {
                DataHelper.publishContent(
                  [sData],
                  () => {
                    message.success(t.publishedSuccess);
                    this.reloadPage();
                  },
                  this.props,
                );
              } catch (err) {
                console.log(err);
              }
            }}
            onPreviewContent={(screenData, previewDims) =>
              this.previewScreenContent(screenData, previewDims)
            }
          ></ScreenTableView>
        )}
        <MediaPreviewPopup ref={this.mediaPreviewPopupRef}></MediaPreviewPopup>
        <ScreenPreviewPopup
          key="screen_preview"
          ref={this.screenPreviewPopupRef}
        />
      </MainLayout>
    );
  };

  render() {
    var view = this.getScreensView();
    return view;
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    globalSearch: state.globalSearch,
    selectedBrandData: state.selectedBrandData,
    selectedBranchData: state.selectedBranchData,
    selectedPage: state.selectedPage,
  };
};

export default connect(mapStateToProps, {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectBranch,
  selectPage,
})(ScreenPage);
